export const CAMPAIGN_TAB_ID = {
  BRIEF: 'brief',
  RECRUIT: 'recruit',
  INVITES: 'invites',
  PROPOSALS: 'proposals',
  FULFILLMENT: 'fulfillment',
  DISCOUNT_CODES: 'discount-codes',
  CONTRACTS: 'contracts',
  DOWNLOADS: 'downloads',
  STATS: 'stats',
  SETTINGS: 'settings',
  TIMELINE: 'timeline',
  CREATORS: 'creators',
  ASSETS: 'assets',
  STATISTICS: 'statistics',
} as const;

export type CampaignTabId =
  (typeof CAMPAIGN_TAB_ID)[keyof typeof CAMPAIGN_TAB_ID];
